export const getters = {
  invoiceItemsrows: state => state.invoice_items,
  containerItemsrows: state => state.container_details,
  systemInvoices: state => state.invoices
};

export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/invoices/getters.js